export default __webpack_public_path__ + "static/media/petal_PhysicalHealth.a946e99a.svg";